var styles = {"box":"User_box_5zbs3_1","toolbar":"User_toolbar_5zbs3_13","edit":"User_edit_5zbs3_16","save":"User_save_5zbs3_17"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
